<template>
    <div style="display:inline">
        <span @click="showModalTemp()"
              style="
                              width: 30px;
                              height: 30px;
                              border-radius: 5px;
                              background-color: #212121;
                              color: white;
                              display: inline-block;
                              padding-left: 5px;
                              padding-right: 5px;
                              text-align: center;
                              cursor:pointer;
                              margin-right: 8px;
                              ">
            <i class="fa fa-plus" style="margin-top:7px;" aria-hidden="true"></i>
        </span>
        <modal :scrollable="true" name="control-panel-add-form" @before-open="beforeOpen" height="auto" :minHeight="800" width="80%">

            <div class="" id="contorlPanelAddModal" role="dialog">
                <div class="">
                    <!-- Modal content-->
                    <div class="modal-content">
                        <div style="padding:15px;">
                            <div class="row">
                                <div class="col-8">
                                    <div class="text-left section-title" style="padding: 5px;">
                                        <span class="row-table-font-margins" style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center'>
                                            <template v-if="buildingId">
                                                <span row-table-font-margins style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center;'> {{ buildingName}} / </span>
                                            </template>
                                            Form
                                        </span>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="text-right" style="padding: 5px;">
                                        <a style="margin-left:6px;display:inline-block;" class="btn btn-table" @click.prevent="hide()"><i class="fas fa-times"></i></a>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <select class="form-control" v-model="type">
                                        <optgroup label="Expenses">
                                            <option v-if="building.useMonthlyExpenses" value="1">Monthly Expenses</option>
                                            <option value="2">Additional Expenses</option>
                                        </optgroup>
                                        <optgroup label="Principals">
                                            <option value="3">Pay Now</option>
                                        </optgroup>
                                        <optgroup label="Uncollected Income">
                                            <option v-if="building.useMonthlyExpenses" value="4">Collect Monthly Income</option>
                                            <option value="5">Collect Shared Payment</option>
                                        </optgroup>
                                        <!--<optgroup label="Credit Notes">
                                            <option v-if="building.useMonthlyExpenses" value="6">Credit Note Monthly Expenses</option>
                                            <option value="7">Credit Note Additional Expenses</option>
                                            <option value="8">Credit Note Expenses</option>
                                        </optgroup>-->
                                    </select>
                                </div>
                            </div>
                            <expense-form v-if="type=='1'" :building-id="buildingId"></expense-form>
                            <additional-expense-form v-if="type=='2'" :building-id="buildingId"></additional-expense-form>
                            <expensepayment-form v-if="type=='3'" :building-id="buildingId"></expensepayment-form>
                            <collect-monthly-payment-form v-if="type=='4'" :building-id="buildingId" :period="period"></collect-monthly-payment-form>
                            <collectpayment-form v-if="type=='5'" :building-id="buildingId"></collectpayment-form>
                            <creditnote-monthly-form v-if="type=='6'" :building-id="buildingId"></creditnote-monthly-form>
                            <creditnote-additional-form v-if="type=='7'" :building-id="buildingId"></creditnote-additional-form>
                            <creditnote-expenses-form v-if="type=='8'" :building-id="buildingId"></creditnote-expenses-form>
                            <!--<a type="button"
    class="close"
    style="line-height: 0; color: #fff; opacity: 1;"
    @click="hide()"
    data-dismiss="modal">&times;</a>-->

                        </div>
                        </div>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
import { mapState } from "vuex";
export default {
        props: ["buildingId", "period","buildingName"],
  data: function () {
      return {
          type:1
      };
  },

  mounted() {
      if (this.building.useMonthlyExpenses)
          this.type = 1
      else
          this.type = 2
    //alert(this.buildingId);
  },

  methods: {
    beforeOpen(event) {},
    showModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    fetchStatement: function () {},
    showModalTemp: function () {
        this.$modal.show("control-panel-add-form");
      //alert("Id " + expenseId + " month " + month);
      //this.isModalVisible = true;
    },
    show() {
        this.$modal.show("control-panel-add-form");
    },
    hide() {
      
        this.$modal.hide("control-panel-add-form");
    },

    /**
     * Prepare the component.
     */
  },

  computed: {
    ...mapState({
      building: (state) => state.building.currentBuilding,
      buildings: (state) => state.building.buildings,
      numberOfAllowedBuildings: (state) =>
        state.building.numberOfAllowedBuildings,
    }),
    buildingName(){
      if(this.building != null)
        return  this.building.name;
      return ""
    },
   
  },
}; // Our Javascript logic
</script>